import { render, staticRenderFns } from "./index.vue?vue&type=template&id=61326016&"
import script from "./Project.js?vue&type=script&lang=js&"
export * from "./Project.js?vue&type=script&lang=js&"
import style0 from "./Project.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports